import { apiClient } from '../../apiClient';

export const productService = {
  // Get all products
  getAllProducts: () => apiClient.get('/products'),

  // Get products by shop
  getProductsByShop: (shopId) => apiClient.get(`/products/shop/${shopId}`),

  // Get product by ID
  getProductById: (id) => apiClient.get(`/products/${id}`),

  // Create product
  createProduct: (data) => apiClient.post('/products', data),

  // Update product
  updateProduct: (id, data) => apiClient.put(`/products/${id}`, data),

  // Delete product
  deleteProduct: (id) => apiClient.delete(`/products/${id}`),

  /** Public — same list as footer */
  getDefaultServiceTags: () => apiClient.get('/products/tags/defaults'),

  /** Authenticated vendor — defaults + tags used on own products */
  getVendorTagSuggestions: () => apiClient.get('/products/tags/suggestions'),
};
